import Wrapper from './Wrapper';
import UserId from './UserId';
import OsInfo from './OsInfo';
import Category from './Category';
import Email from './Email';
import Title from './Title';
import Content from './Content';
import AttachedFiles from './AttachedFiles';
import Agreement from './Agreement';
import ActionButtons from './ActionButtons';
import CautionBox from './CautionBox';
import ReporterName from './ReporterName';
import Birth from './Birth';
import PhoneNumber from './PhoneNumber';

export const FormGroup = Object.assign(Wrapper, {
  UserId,
  OsInfo,
  Category,
  Email,
  Title,
  Content,
  AttachedFiles,
  Agreement,
  ActionButtons,
  CautionBox,
  ReporterName,
  Birth,
  PhoneNumber,
});
